module.exports = __webpack_public_path__ + "a36c57ef7767138aeeec9b85d00a21eb.pdf";